<template>
    <div>
        <div class="action-header">
            <div class="search-container">
                <div class="search-input">
                    <v-text-field
                        v-model="search"
                        prepend-inner-icon="search"
                        :placeholder="this.$vuetify.lang.t('$vuetify.blacklist.searchText')"
                        solo
                        height="40px"
                        dense
                        @keyup.enter="searchBlacklist()">
                    </v-text-field>

                    <div class="ml-3">
                        <v-btn
                            height="40"
                            color="primary"
                            outlined
                            @click="searchBlacklist()">
                            {{ $vuetify.lang.t('$vuetify.blacklist.search') }}
                        </v-btn>
                    </div>
                </div>

                <div class="filter-input">
                    <div class="status-filter">
                        <v-select
                            @change="getBlacklists()"
                            v-model="blacklistStatus"
                            :items="blacklistStatusDropdown"
                            item-text="text"
                            item-value="value"
                            outlined
                            dense
                            height="40"
                            background-color="#ffffff">
                        </v-select>
                    </div>
                </div>
            </div>
            <div>
                <v-btn
                    v-if="canUpdate"
                    height="40"
                    @click="createNewBlacklist()"
                    color="primary"> + {{ $vuetify.lang.t('$vuetify.blacklist.createBlacklist') }} </v-btn>
            </div>
        </div>
        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :options.sync="options"
                :server-items-length="totalBlacklist"
                :items="blacklists"
                @click:row="seeDetail"
                :loading="loading">
                <template v-slot:[`item.status`]="{ item }">
                    <div>
                        <span :class="statusStyle(item.status)">{{item.status}}</span>
                    </div>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                    <div class="action" v-if="canUpdate">
                        <i
                            class="far fa-edit mr-3"
                            @click.stop="goToEditBlacklist(item.id)">
                        </i>
                        <i
                            class="far fa-trash-alt"
                            @click.stop="openDeleteBlacklistModal(item)">
                        </i>
                    </div>
                </template>
            </v-data-table>
        </v-card>

        <delete-modal
            ref="modalDelete"
            @success-deleted="deleteSuccess()"
            :deleteForm="deleteForm"/>
    </div>
</template>

<script>
import DeleteModal from '@/components/modal/DeleteModal.vue'
export default {
    name: 'BlacklistLists',

    components: {
        DeleteModal
    },

    data () {
        return {
            search: '',
            pageCount: 1,
            page: 1,
            options: {},
            blacklists: [],
            totalBlacklist: 0,
            loading: false,
            blacklistStatus: null,
            blacklistStatusDropdown: [],
            canUpdate: false,
            deleteForm: {
                header: this.$vuetify.lang.t('$vuetify.blacklist.deleteBlacklist'),
                content: '',
                path: ''
            }
        }
    },

    computed: {
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.blacklist.blacklistName'), value: 'fullName', width: '60%' },
                { text: this.$vuetify.lang.t('$vuetify.blacklist.dateCreate'), value: 'created_at', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.blacklist.status'), value: 'status', width: '15%' },
                { text: '', value: 'action', width: '10%', sortable: false }
            ]
        }
    },

    methods: {
        statusStyle (status) {
            if (status === 'Deactive' || status === 'ปิดการใช้งาน') {
                return 'inactive-status-text'
            }
        },
        async searchBlacklist () {
            this.options.page = 1
            await this.getBlacklists()
        },

        async getBlacklistStatusList () {
            const res = await this.axios.get('blacklist/status')
            if (res && res.data && res.data.status === 'ok') {
                this.blacklistStatusDropdown = res.data.data
            }
        },

        async getBlacklists () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `blacklists?page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            if (this.blacklistStatus) {
                url += `&status=${this.blacklistStatus}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.blacklists = res.data.data
                this.totalBlacklist = res.data.total
                this.loading = false
            }
        },

        createNewBlacklist () {
            this.$router.push({ name: 'BlacklistForm' }, () => {})
        },

        goToEditBlacklist (id) {
            this.$router.push({ name: 'BlacklistForm', params: { id } }, () => {})
        },

        openDeleteBlacklistModal (blacklist) {
            this.deleteForm.content = `${this.$vuetify.lang.t('$vuetify.blacklist.wantToDelete')} "${blacklist.fullName}"? `
            this.deleteForm.path = `blacklist/delete/${blacklist.id}`
            this.$refs.modalDelete.dialog = true
        },

        async deleteSuccess () {
            await this.getBlacklists()
            this.$notify({
                title: this.$vuetify.lang.t('$vuetify.blacklist.congratulation'),
                text: this.$vuetify.lang.t('$vuetify.blacklist.blacklistIsDeleted'),
                type: 'notify-success'
            })
        },

        seeDetail (item) {
            this.$router.push({ name: 'BlacklistInfo', params: { id: item.id } }, () => {})
        }
    },

    async mounted () {
        this.canUpdate = await this.hasPermission(this.$constant.permission.BLACKLIST.UPDATE)
        await this.getBlacklistStatusList()
    },

    watch: {
        options: {
            async handler () {
                await this.getBlacklists()
            },
            deep: true
        },

        '$vuetify.lang.current': {
            handler: async function (after, before) {
                await this.getBlacklists()
                await this.getBlacklistStatusList()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.search-container {
    ::v-deep .v-input__control > .v-input__slot {
        min-height: auto !important;
        display: flex !important;
        align-items: center !important;
        box-shadow: none !important;
        border: 1px solid #a8a8a8 !important;
        width: 340px;
    }

    ::v-deep .status-filter {
        .v-input__control > .v-input__slot {
            border: none !important;
            width: 200px;
        }

        .v-select__selection{
            line-height: 1.75;
        }
    }
}
.inactive-status-text {
    color: #ff544a;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr {
    & td:not(:last-child) {
        cursor: pointer;
    }

    & td:last-child {
        cursor: default;
    }
}
</style>
